import React, { useCallback, useEffect, useState, useRef } from "react";

import {isNaN, uniqueId } from "lodash";

export const TranscriptBlocks = ({transcriptionSections, jumpToAudio, audioPlayer}) => {


    const [currentTime, setCurrentTime] = useState(-1);

    const synchronizeText = useCallback(() => {
        if(!(audioPlayer && audioPlayer.current))
            return;
        const actualCurrentTime = audioPlayer.current.audio.current.currentTime;
        setCurrentTime(actualCurrentTime);
    }, [setCurrentTime, currentTime, audioPlayer]);

    useEffect(() => {
        const audioPlayerElement = audioPlayer?.current?.audio?.current;
        audioPlayerElement?.addEventListener("timeupdate", synchronizeText);
        return () =>
            audioPlayerElement?.removeEventListener("timeupdate", synchronizeText);
    }, [audioPlayer, synchronizeText]);
    
    
    const speakerBlocks = transcriptionSections.reduce(
            (acc, next) => acc && acc.length > 0 && acc[acc.length - 1].speaker === next.speaker ?
                acc[acc.length - 1].sections.push(next) && acc : [...acc, {speaker: next.speaker, sections: [next]}],
            []
        )

    return <div className="space-y-2.5">{speakerBlocks.map(
            (speakerBlock, idx) => {
            
            const highlightBlockSpeaker = 
                currentTime >= speakerBlock.sections[0].start && 
                currentTime < speakerBlock.sections[speakerBlock.sections.length - 1].end;

            return <p key={idx}>
                        {speakerBlock.speaker ?
                        <span className={["cursor-pointer",...(highlightBlockSpeaker ? ["text-black"] : ["text-black/50"])].join(" ")} 
                            onClick={() => jumpToAudio(speakerBlock.sections[0].start)}>
                             <strong>{`[${speakerBlock.speaker}]: `}</strong>
                        </span> : ""}
                        {speakerBlock.sections.map((section, idx2) => {
                            const toggleHighlight = currentTime >= section.start && currentTime < section.end;
                        return <Sentence key={idx2} section={section} 
                        legacyMode={speakerBlocks.length === 1}
                        toggleHighlight={toggleHighlight} 
                        jumpToAudio={jumpToAudio}
                        />;
                        })}
                    </p>;
        })}</div>;
};


const Sentence = ({section, toggleHighlight, jumpToAudio, legacyMode}) => {
    const textRef = useRef();
    const {
        sentence,
        conceptList,
        start
    } = section;   

    useEffect(() => {
        if(toggleHighlight && textRef.current) {
            textRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [textRef, toggleHighlight])

    const spanClass = [..."cursor-pointer".split(" "), 
        ...(toggleHighlight ? ["text-black"] : ["text-black/50"]), 
        ...(legacyMode ? ["whitespace-pre-wrap"] : [])].join(" ");

    return <>
    <span ref={(span) => textRef.current = span}
        className={spanClass}
        onClick={() => jumpToAudio(start)}>
        {sentenceWithHighlights(sentence, conceptList)}
    </span></>;
}




function sentenceWithHighlights(sentence, conceptList) {

    if(!(conceptList && conceptList.length > 0))
        return sentence;

    const positionsList = [
        ...conceptList
            .filter(c => c.positions)
            .flatMap(c => c.positions.map(p => ({start : p.start, end: p.end + 1})))]; //copy

    if(positionsList.length === 0)
        return sentence;

    const [startIndex, endIndex] = [0, sentence.length];
    positionsList.sort(
        (a, b) => a.start - b.start === 0 ? 
        a.end - b.end : a.start - b.start);

    let lastIndex = startIndex;
    let result = [];
    let stack = [positionsList.shift()];
    do {

        if(stack.length === 0) {
        result = 
            [...result, 
            ...(lastIndex < endIndex ?
            [sentence.substr(lastIndex, endIndex - lastIndex)] : [])
            ]
        break;
        }

        result = [...result, 
        ...(lastIndex < stack[0].start ?
            [sentence.substr(lastIndex, stack[0].start - lastIndex)] : []),
        <strong key={uniqueId("concept")}>
            {sentence.substr(stack[0].start, 
                        stack[0].end - stack[0].start)}
        </strong>];

        lastIndex = stack[0].end;
        const next = positionsList.shift()
        stack = next ? [next] : [];
    } while(lastIndex < endIndex)


    return result;

}